import React, { useState } from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MultiCompanySelect from '../selectors/company/MultiCompanySelect';
import { Link } from 'react-router-dom';

const toCompanyPermissionsPageUrl = '/CompanyPermissions';
const ALL_COMPANIES_GRANT = '*';

const CompanyPermissionsForm = (props) => {
    const [allCompaniesChecked, setAllCompaniesChecked] = useState(Boolean(props.selectedCompanies?.includes(ALL_COMPANIES_GRANT)));
    const [selectedCompanies, setSelectedCompanies] = useState(props.selectedCompanies);

    const onAllCompaniesChange = (e) => {
        setAllCompaniesChecked(e.target.checked);
    }

    const onCompanySelectionHandler = (e) => {
        let companies = (selectedCompanies || []).slice();
        companies.push(e.value);
        setSelectedCompanies(companies);
    }

    const onCompanyDeselectionHandler = (e) => {
        let companies = (selectedCompanies || []).filter(t => t !== e.value);
        setSelectedCompanies(companies);
    }

    const onSaveChanges = () => {
        let companyGrants;
        if (allCompaniesChecked) {
            companyGrants = [ALL_COMPANIES_GRANT];
        }
        else {
            companyGrants = (selectedCompanies || []).filter(c => c !== ALL_COMPANIES_GRANT);
        }
        if (typeof props.editHandler === 'function') {
            props.editHandler(companyGrants);
        }
    }

    const createFormElement = () => {
        return (
            <div data-testid="comp-perm-form">
                <form>
                    <fieldset>
                        {
                            <div data-testid="company-selector">
                                <input type="checkbox"
                                    id="allCompanies"
                                    data-testid="all-companies-checkbox"
                                    className="absolute"
                                    checked={allCompaniesChecked}
                                    onChange={onAllCompaniesChange} />
                                <label htmlFor="allCompanies"><LanguageStringResolver string='CompanyPermissions_AllCompanies' /></label>
                                <label className="mt10"><LanguageStringResolver string='SelectCompany' /></label>
                                <MultiCompanySelect
                                    fieldName={'companyCode'}
                                    valueCompanyCode={false}
                                    showSelectionCount={false}
                                    disabled={allCompaniesChecked}
                                    selectionHandler={onCompanySelectionHandler}
                                    deselectionHandler={onCompanyDeselectionHandler}
                                    selectedCompanyIds={selectedCompanies}
                                    companyList={props.allCompanies}
                                />
                            </div>
                        }
                        <hr className="mt40 mb20" />
                        <div>
                            <Link
                                className="button secondary float-left"
                                to={toCompanyPermissionsPageUrl}
                                data-testid="cancel-edit-comp-perm"
                            >
                                <LanguageStringResolver string="EditCompanyPermissions_Cancel" />
                            </Link>
                            <Link
                                className="button primary float-right"
                                to="#"
                                data-testid="save-comp-perm-on-edit"
                                onClick={onSaveChanges}
                            >
                                <LanguageStringResolver string="EditCompanyPermissions_Save" />
                            </Link>
                        </div>
                    </fieldset>
                </form>
            </div>
        );
    }

    return createFormElement();
}

export default CompanyPermissionsForm;
